import {Injectable} from '@angular/core';
import {ActionWithPayload} from '@catcore/types/base';
import {ResourceAction, ResourceActions} from '@catfeatures/actions/resource.actions';
import {GenericResourceApiService} from '@catfeatures/services/generic-resource-api.service';
import {Actions, Effect} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import 'rxjs/add/operator/switchMap';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ResourceEffects {
  @Effect()
  loadResource$: Observable<Action> = this.actions$
    .ofType(ResourceActions.REQUEST_RESOURCE)
    .switchMap((action: ActionWithPayload<ResourceAction>) => this.genericResourceApiService.resolveForId(action.payload.resourceRef))
    .map((resource: any) => this.resourceActions$.resourceLoaded(resource));

  @Effect()
  saveResource$: Observable<Action> = this.actions$
    .ofType(ResourceActions.SAVE_RESOURCE)
    .switchMap((action: ActionWithPayload<ResourceAction>) => this.genericResourceApiService.save(
      action.payload.resourceRef,
      action.payload.resource,
    ))
    .map((resource: any) => this.resourceActions$.resourceSaved(resource))
    .map((resource: any) => this.resourceActions$.resourceLoaded(resource));

  constructor(private actions$: Actions,
              private genericResourceApiService: GenericResourceApiService,
              private resourceActions$: ResourceActions) {
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/effects/resource.effects.ts